import { createTimeline, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger, BLUR } from '../motion-tokens.js';

export const faqV1 = (el) => {
    const items = el.querySelectorAll('.faq-item, .faq-card, [class*="faq-item"]');
    const bars  = el.querySelectorAll('.faq-bar, .faq-border, [class*="border-left"], [class*="faq-accent"]');

    bars.forEach(b => { b.style.opacity = '0.3'; b.style.transform = 'scaleY(0)'; b.style.transformOrigin = 'top center'; });
    items.forEach(item => { item.style.opacity = '0'; item.style.transform = 'translateX(-20px)'; });

    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    if (bars.length) {
        tl.add(bars, {
            scaleY:          [0, 1],
            opacity:         [0.3, 1],
            delay:           stagger(resolveStagger(STAGGER.normal)),
            duration:        resolveDuration(DURATION.slow),
            transformOrigin: 'top center',
        });
    }

    if (items.length) {
        tl.add(items, {
            opacity:    [0, 1],
            translateX: [-20, 0],
            delay:      stagger(resolveStagger(STAGGER.normal)),
            duration:   resolveDuration(DURATION.normal),
        }, bars.length ? '-=500' : 0);
    }

    return tl;
};

export const faqV2 = (el) => {
    const lines = el.querySelectorAll('.faq-line, .faq-separator, hr, [class*="faq-border-b"]');
    const texts = el.querySelectorAll('.faq-item h3, .faq-item p, .faq-question, .faq-answer');

    lines.forEach(l => { l.style.opacity = '0'; l.style.transform = 'scaleX(0)'; l.style.transformOrigin = 'left center'; });
    texts.forEach(t => { t.style.opacity = '0'; t.style.transform = 'translateY(8px)'; });

    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    if (lines.length) {
        tl.add(lines, {
            scaleX:          [0, 1],
            opacity:         [0, 1],
            delay:           stagger(resolveStagger(STAGGER.fast)),
            duration:        resolveDuration(DURATION.normal),
            transformOrigin: 'left center',
        });
    }

    if (texts.length) {
        tl.add(texts, {
            opacity:    [0, 1],
            translateY: [8, 0],
            delay:      stagger(resolveStagger(STAGGER.fast)),
            duration:   resolveDuration(DURATION.normal),
        }, lines.length ? '-=300' : 0);
    }

    return tl;
};

export const faqV3 = (el) => {
    const items = [...el.querySelectorAll('.faq-item, .faq-card')];
    if (!items.length) return null;

    const mid   = Math.ceil(items.length / 2);
    const left  = items.slice(0, mid);
    const right = items.slice(mid);
    const tl = createTimeline({ defaults: { ease: EASE.snappy }, });

    if (left.length) tl.add(left, {
        opacity:    [0, 1],
        translateX: [-50, 0],
        filter:     [BLUR.normal, BLUR.none],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.slow),
    }, 0);

    if (right.length) tl.add(right, {
        opacity:    [0, 1],
        translateX: [50, 0],
        filter:     [BLUR.normal, BLUR.none],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.slow),
    }, 150);

    return tl;
};
